// extracted by mini-css-extract-plugin
export default {"title":"Cropper_title__ZTwxV","wrapper":"Cropper_wrapper__VRd4x","content":"Cropper_content__h7Twy","image":"Cropper_image__8VX7S","actions":"Cropper_actions__dQKTa"};